import { Abas } from '@core/components/Abas';
import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { mensagemCampoObrigatorio, mensagemMinimo3Caracteres } from '@core/util/mensagemUtil';
import { cancelarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import { GlobalContext } from 'app/store/globalcontext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import * as Yup from 'yup';
import { ProdutoContext } from '../../../ProdutoContext';
import { produtoModais } from '../produtoModais';
import TabDadosFiscaisProduto from './TabDadosFiscaisProduto';
import TabDadosProduto from './TabDadosProduto';
import TabImagensProduto from './TabImagensProduto';

const produtoAbas = {
  dadosProduto: 0,
  dadosFiscais: 1,
  imagens: 2,
};

const CadastroProdutoModal = ({ onSubmit, onUploadImage }) => {
  const [produto] = useContext(ProdutoContext).produtoAtual;
  const [modal, setModal] = useContext(ProdutoContext).modal;
  const [search] = useContext(ProdutoContext).search;
  const [page] = useContext(ProdutoContext).page;
  const [size] = useContext(ProdutoContext).size;
  const [abaSelecionada, setAbaSelecionada] = useState(produtoAbas.dadosProduto);
  const [, setEmpresa] = useContext(GlobalContext).empresa;
  const [possuiIpi] = useContext(GlobalContext).possuiIpi;
  const [empresaIbsCbs, setEmpresaIbsCbs] = useState(false);

  useEffect(() => {
    async function buscarEmpresa() {
      const response = await empresaApi.buscar(getEmpresaContexto());
      // response.data.optanteSimples = true;
      setEmpresa(response.data);

      try {
        if (
          response?.data?.ibsCbs &&
          (response?.data?.contribuinteIbs || response?.data?.contribuinteCbs || response?.data?.contribuinteIs)
        ) {
          formik.values.fiscal.ibsCbs = true;
          setEmpresaIbsCbs(true);
        }
      } catch (error) {
        setEmpresaIbsCbs(false);
      }
    }

    buscarEmpresa();
    // Efeito de montagem: incluir as dependências reexecutaria a carga inicial a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emPromocao =
    produto.promocao &&
    moment()
      .startOf('day')
      .isBetween(produto.promocao.vigenciaInicio, produto.promocao.vigenciaFim, undefined, '[]');

  const initialValues = {
    id: produto?.id || null,
    nome: produto?.nome || null,
    codigo: produto?.codigo || null, // código é o SKU...
    descricaoDetalhada: produto?.descricaoDetalhada || null,
    tipoFinalidade: produto?.tipoFinalidade || 'VAZIO',
    valorUnitario: produto?.valorUnitario || null,
    estoqueMinimo: produto?.estoqueMinimo || null,
    estoqueMaximo: produto?.estoqueMaximo || null,
    quantidadeEstoque: produto?.quantidadeEstoque || null,
    possuiMovimentacao: produto?.possuiMovimentacao || false,
    custoMedio: produto?.custoMedio || false,
    codigoBarras: produto?.codigoBarras || null,
    emPromocao: emPromocao || false,
    imagens: produto?.imagens || [],
    dataValidade: produto?.dataValidade || null,
    promocao: {
      vigenciaInicio:
        emPromocao && produto?.promocao?.vigenciaInicio ? moment(produto?.promocao?.vigenciaInicio) : null,
      vigenciaFim: emPromocao && produto?.promocao?.vigenciaFim ? moment(produto?.promocao?.vigenciaFim) : null,
      tipoDesconto: (emPromocao && produto?.promocao?.tipoDesconto) || 'VALOR',
      desconto: (emPromocao && produto?.promocao?.desconto) || null,
    },
    fiscal: {
      id: produto?.fiscal?.id,
      codigoNCM: produto?.fiscal?.codigoNCM || null,
      cfop: produto?.fiscal?.cfop || null,
      cest: produto?.fiscal?.cest || null,
      tipoUnidadeMedida: produto?.fiscal?.tipoUnidadeMedida || 'VAZIO',
      pesoLiquido: produto?.fiscal?.pesoLiquido || null,
      pesoBruto: produto?.fiscal?.pesoBruto || null,
      altura: produto?.fiscal?.altura || null,
      largura: produto?.fiscal?.largura || null,
      profundidade: produto?.fiscal?.profundidade || null,
      origemProduto: produto?.fiscal?.origemProduto || null,
      icms: {
        situacaoTributaria: produto?.fiscal?.icms?.situacaoTributaria || null,
        codigoTributario: produto?.fiscal?.icms?.codigoTributario || null,
        motivoDesoneracao: produto?.fiscal?.icms?.motivoDesoneracao || null,
        possuiIcms: produto?.fiscal?.icms?.possuiIcms || false,
        ufIcmsStDevido: produto?.fiscal?.icms?.ufIcmsStDevido || null,
        modalidadeDeterminacaoBcIcmsST: produto?.fiscal?.icms?.modalidadeDeterminacaoBcIcmsST || null,
        modalidadeDeterminacaoBC: produto?.fiscal?.icms?.modalidadeDeterminacaoBC || null,
        reducaoBC: produto?.fiscal?.icms?.reducaoBC || null,
        valorBC: produto?.fiscal?.icms?.valorBC || null,
        aliquotaImposto: produto?.fiscal?.icms?.aliquotaImposto || null,
        aliquotaRelativoFcp: produto?.fiscal?.icms?.aliquotaRelativoFcp || null,
        valorBcFcp: produto?.fiscal?.icms?.valorBcFcp || null,
        reducaoBcIcmsSt: produto?.fiscal?.icms?.reducaoBcIcmsSt || null,
        mvaIcmsSt: produto?.fiscal?.icms?.mvaIcmsSt || null,
        aliquotaImpostoIcmsSt: produto?.fiscal?.icms?.aliquotaImpostoIcmsSt || null,
        valorBcFcpRetidoSt: produto?.fiscal?.icms?.valorBcFcpRetidoSt || null,
        fcpRetidoSt: produto?.fiscal?.icms?.fcpRetidoSt || null,
        reducaoBCEfetiva: produto?.fiscal?.icms?.reducaoBCEfetiva || null,
        valorDesoneracao: produto?.fiscal?.icms?.valorDesoneracao || null,
        valorBcIcmsSt: produto?.fiscal?.icms?.valorBcIcmsSt || null,
        valorIcmsOperacao: produto?.fiscal?.icms?.valorIcmsOperacao || null,
        diferimento: produto?.fiscal?.icms?.diferimento || null,
        valorBcIcmsStRetido: produto?.fiscal?.icms?.valorBcIcmsStRetido || null,
        aliquotaSuportadaConsumidorFinal: produto?.fiscal?.icms?.aliquotaSuportadaConsumidorFinal || null,
        valorIcmsStRetido: produto?.fiscal?.icms?.valorIcmsStRetido || null,
        valorIcmsProprioSubstituto: produto?.fiscal?.icms?.valorIcmsProprioSubstituto || null,
        valorBcFcpRetidoAnteriormenteSt: produto?.fiscal?.icms?.valorBcFcpRetidoAnteriormenteSt || null,
        fcpRetidoAnteriormenteSt: produto?.fiscal?.icms?.fcpRetidoAnteriormenteSt || null,
        valorBCEfetiva: produto?.fiscal?.icms?.valorBCEfetiva || null,
        aliquotaIcmsEfetiva: produto?.fiscal?.icms?.aliquotaIcmsEfetiva || null,
        aliquotaAplicavelCalculoCredito: produto?.fiscal?.icms?.aliquotaAplicavelCalculoCredito || null,
        valorCreditoIcms: produto?.fiscal?.icms?.valorCreditoIcms || null,
        bcOperacaoPropria: produto?.fiscal?.icms?.bcOperacaoPropria || null,
      },
      ipi: {
        situacaoTributaria: produto?.fiscal?.ipi?.situacaoTributaria || null,
        codigoEnquadramento: produto?.fiscal?.ipi?.codigoEnquadramento || null,
        aliquota: produto?.fiscal?.ipi?.aliquota || null,
        valorBc: produto?.fiscal?.ipi?.valorBc || null,
        tributacaoExclusivaPorUnidade: produto?.fiscal?.ipi?.tributacaoExclusivaPorUnidade || null,
      },
      valorIbs: produto?.fiscal?.valorIbs || null,
      valorCbs: produto?.fiscal?.valorCbs || null,
      valorIs: produto?.fiscal?.valorIs || null,
      cstSituacaoTributaria: {
        id: produto?.fiscal?.cstSituacaoTributaria?.id || '',
        codigo: produto?.fiscal?.cstSituacaoTributaria?.codigo || '',
        descricao: produto?.fiscal?.cstSituacaoTributaria?.descricao || '',
        idSituacao: produto?.fiscal?.cstSituacaoTributaria?.idSituacao || '',
      },
      cstClassificacaoTributaria: {
        id: produto?.fiscal?.cstClassificacaoTributaria?.id || '',
        codigo: produto?.fiscal?.cstClassificacaoTributaria?.codigo || '',
        descricao: produto?.fiscal?.cstClassificacaoTributaria?.descricao || '',
        cstPaiId: produto?.fiscal?.cstClassificacaoTributaria?.cstPaiId || '',
      },
      ibsCbs: false,
    },
  };

  const produtoSchema = Yup.object().shape({
    nome: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('o nome do produto'))
      .min(3, mensagemMinimo3Caracteres)
      .max(50, 'Não pode ultrapassar 50 caracteres'),
    codigo: Yup.string()
      .nullable()
      .max(30, 'Não pode ultrapassar 30 caracteres'),
    descricaoDetalhada: Yup.string()
      .nullable()
      .min(3, mensagemMinimo3Caracteres)
      .max(500, 'Não pode ultrapassar 500 caracteres'),
    tipoFinalidade: Yup.string().nullable(),
    valorUnitario: Yup.number().nullable(),
    estoqueMaximo: Yup.number().nullable(),
    /* .test('maiorQueEstoqueMinimo', 'Estoque máximo não pode ser menor que o estoque mínimo', (estoqueMaximo) => {
        const estoqueMaximoPreenchido = estoqueMaximo !== null && estoqueMaximo !== undefined && estoqueMaximo !== '';
        const estoqueMinimoPreenchido = formik.values.estoqueMinimo !== null && formik.values.estoqueMinimo !== undefined && formik.values.estoqueMinimo !== ''; 

        return !(estoqueMinimoPreenchido && estoqueMaximoPreenchido) || estoqueMaximo >= formik.values.estoqueMinimo;
      }), */
    fiscal: Yup.object().shape({
      pesoBruto: Yup.number().nullable(),
      /* .test('maiorQuePesoLiquido', 'Peso bruto não pode ser menor que o peso líquido', (pesoBruto) => {
          return pesoBruto === null || pesoBruto === undefined || pesoBruto >= formik.values.fiscal?.pesoLiquido;
        }), */
      origemProduto: Yup.object()
        .nullable()
        .test('validaOrigemProduto', mensagemCampoObrigatorio('Origem do produto'), () => {
          return !(formik.values?.fiscal?.icms?.possuiIcms && !formik.values?.fiscal?.origemProduto?.id);
        }),
      icms: Yup.object().shape({
        situacaoTributaria: Yup.object()
          .nullable()
          .test('validaSituacaoTributaria', mensagemCampoObrigatorio('Situação tributária'), () => {
            return !(formik.values?.fiscal?.icms?.possuiIcms && !formik.values?.fiscal?.icms?.situacaoTributaria?.id);
          }),
        modalidadeDeterminacaoBcIcmsST: Yup.string()
          .nullable()
          .test(
            'validaModalidadeDeterminacaoBcIcmsST',
            mensagemCampoObrigatorio('Modalidade de determinação da BC do ICMS ST'),
            function(modalidadeDeterminacaoBcIcmsST) {
              const { codigoTributario } = this.parent;

              if (codigoTributario === '90' || codigoTributario === '900') {
                if (this.parent.valorBcIcmsSt === '0') {
                  return true;
                }
                if (this.parent.aliquotaImpostoIcmsSt === '0') {
                  return true;
                }
                if (this.parent.bcOperacaoPropria === '0') {
                  return true;
                }
                if (
                  codigoTributario === '90' &&
                  (this.parent.valorBcIcmsSt || this.parent.aliquotaImpostoIcmsSt) &&
                  !modalidadeDeterminacaoBcIcmsST
                ) {
                  return false;
                }
                if (
                  codigoTributario === '900' &&
                  (this.parent.valorBcIcmsSt ||
                    this.parent.aliquotaImpostoIcmsSt ||
                    this.parent.bcOperacaoPropria ||
                    this.parent.ufIcmsStDevido?.id) &&
                  !modalidadeDeterminacaoBcIcmsST
                ) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms.modalidadeDeterminacaoBcIcmsST, [
                '10',
                '30',
                '70',
                '201',
                '202',
                '203',
              ]);
            }
          ),
        modalidadeDeterminacaoBC: Yup.string()
          .nullable()
          .test(
            'validaModalidadeDeterminacaoBC',
            mensagemCampoObrigatorio('Modalidade de determinação da BC'),
            function(modalidadeDeterminacaoBC) {
              const { codigoTributario } = this.parent;

              if (codigoTributario === '90' || codigoTributario === '900') {
                if (this.parent.valorBC === '0') {
                  return true;
                }
                if (this.parent.aliquotaImposto === '0') {
                  return true;
                }
                if ((this.parent.valorBC || this.parent.aliquotaImposto) && !modalidadeDeterminacaoBC) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms.modalidadeDeterminacaoBC, ['00', '10', '20']);
            }
          ),
        valorBC: Yup.string()
          .nullable()
          .test('validaValorBC', mensagemCampoObrigatorio('Valor da BC (R$)'), function(valorBC) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.aliquotaImposto === '0') {
                return true;
              }
              if ((this.parent.modalidadeDeterminacaoBC || this.parent.aliquotaImposto) && !valorBC) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms.valorBC, ['00', '10', '20', '70']);
          }),
        aliquotaImposto: Yup.string()
          .nullable()
          .test('validaAliquotaImposto', mensagemCampoObrigatorio('Alíquota do imposto (%)'), function(
            aliquotaImposto
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.valorBC === '0') {
                return true;
              }
              if ((this.parent.modalidadeDeterminacaoBC || this.parent.valorBC) && !aliquotaImposto) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms.aliquotaImposto, ['00', '10', '20', '70']);
          }),
        aliquotaImpostoIcmsSt: Yup.string()
          .nullable()
          .test('validaAliquotaImpostoIcmsSt', mensagemCampoObrigatorio('Alíquota do imposto do ICMS ST (%)'), function(
            aliquotaImpostoIcmsSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.valorBcIcmsSt === '0') {
                return true;
              }
              if (this.parent.bcOperacaoPropria === '0') {
                return true;
              }
              if (
                codigoTributario === '90' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST || this.parent.valorBcIcmsSt) &&
                !aliquotaImpostoIcmsSt
              ) {
                return false;
              }
              if (
                codigoTributario === '900' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST ||
                  this.parent.valorBcIcmsSt ||
                  this.parent.bcOperacaoPropria ||
                  this.parent.ufIcmsStDevido?.id) &&
                !aliquotaImpostoIcmsSt
              ) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms.aliquotaImpostoIcmsSt, [
              '10',
              '30',
              '70',
              '201',
              '202',
              '203',
            ]);
          }),
        reducaoBC: Yup.string()
          .nullable()
          .test('validaReducaoBC', mensagemCampoObrigatorio('Redução de BC (%)'), () => {
            return validaCamposIcms(formik.values?.fiscal?.icms.reducaoBC, ['20', '70']);
          }),
        valorBcIcmsSt: Yup.string()
          .nullable()
          .test('validaValorBcIcmsSt', mensagemCampoObrigatorio('Valor da BC do ICMS ST (R$)'), function(
            valorBcIcmsSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '90' || codigoTributario === '900') {
              if (this.parent.aliquotaImpostoIcmsSt === '0') {
                return true;
              }
              if (this.parent.bcOperacaoPropria === '0') {
                return true;
              }
              if (
                codigoTributario === '90' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST || this.parent.aliquotaImpostoIcmsSt) &&
                !valorBcIcmsSt
              ) {
                return false;
              }
              if (
                codigoTributario === '900' &&
                (this.parent.modalidadeDeterminacaoBcIcmsST ||
                  this.parent.aliquotaImpostoIcmsSt ||
                  this.parent.bcOperacaoPropria ||
                  this.parent.ufIcmsStDevido?.id) &&
                !valorBcIcmsSt
              ) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms.valorBcIcmsSt, ['10', '30', '70', '201', '202', '203']);
          }),
        aliquotaAplicavelCalculoCredito: Yup.string()
          .nullable()
          .test(
            'validaAliquotaAplicavelCalculoCredito',
            mensagemCampoObrigatorio('Alíquota aplicável de cálculo de crédito (%)'),
            function(aliquotaAplicavelCalculoCredito) {
              const codigoTributario = this.parent.situacaoTributaria?.codigo;

              if (!codigoTributario) return true;

              if (codigoTributario === '201') {
                if (this.parent.valorBcFcpRetidoSt === '0') {
                  return true;
                }
                if (this.parent.fcpRetidoSt === '0') {
                  return true;
                }
                if (this.parent.valorCreditoIcms === '0') {
                  return true;
                }
                if (
                  (this.parent.valorBcFcpRetidoSt || this.parent.fcpRetidoSt || this.parent.valorCreditoIcms) &&
                  !aliquotaAplicavelCalculoCredito
                ) {
                  return false;
                }
                return true;
              }
              if (codigoTributario === '900') {
                if (this.parent.valorCreditoIcms === '0') {
                  return true;
                }
                if (this.parent.valorCreditoIcms && !aliquotaAplicavelCalculoCredito) {
                  return false;
                }
                return true;
              }
              return validaCamposIcms(formik.values?.fiscal?.icms.aliquotaAplicavelCalculoCredito, ['101']);
            }
          ),
        valorCreditoIcms: Yup.string()
          .nullable()
          .test('validaValorCreditoIcms', mensagemCampoObrigatorio('Valor de crédito do ICMS (R$)'), function(
            valorCreditoIcms
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario === '201') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (
                (this.parent.valorBcFcpRetidoSt ||
                  this.parent.fcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito) &&
                !valorCreditoIcms
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito && !valorCreditoIcms) {
                return false;
              }
              return true;
            }
            return validaCamposIcms(formik.values?.fiscal?.icms.valorCreditoIcms, ['101']);
          }),
        valorBcFcp: Yup.string()
          .nullable()
          .test('validaValorBcFcp', mensagemCampoObrigatorio('Valor da BC do FCP (R$) '), function(valorBcFcp) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '00') {
              if (this.parent.aliquotaRelativoFcp === '0') {
                return true;
              }
              if (this.parent.aliquotaRelativoFcp && !valorBcFcp) {
                return false;
              }
              return true;
            }
            return true;
          }),

        aliquotaRelativoFcp: Yup.string()
          .nullable()
          .test('validaAliquotaRelativoFcp', mensagemCampoObrigatorio('Alíquota relativo ao FCP (%)'), function(
            aliquotaRelativoFcp
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '00') {
              if (this.parent.valorBcFcp === '0') {
                return true;
              }
              if (this.parent.valorBcFcp && !aliquotaRelativoFcp) {
                return false;
              }
              return true;
            }
            return true;
          }),
        valorBcFcpRetidoSt: Yup.string()
          .nullable()
          .test('validaValorBcFcpRetidoSt', mensagemCampoObrigatorio('Valor da BC do FCP retido por ST (R$)'), function(
            valorBcFcpRetidoSt
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '101' && codigoTributario !== '900') {
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.valorCreditoIcms === '0') {
                return true;
              }
              if (
                (this.parent.fcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito ||
                  this.parent.valorCreditoIcms) &&
                !valorBcFcpRetidoSt
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.fcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoSt && !valorBcFcpRetidoSt) {
                return false;
              }
              return true;
            }
            return true;
          }),
        fcpRetidoSt: Yup.string()
          .nullable()
          .test('validaFcpRetidoSt', mensagemCampoObrigatorio('FCP retido por ST (%)'), function(fcpRetidoSt) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (codigoTributario !== '101' && codigoTributario !== '900') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.aliquotaAplicavelCalculoCredito === '0') {
                return true;
              }
              if (this.parent.valorCreditoIcms === '0') {
                return true;
              }
              if (
                (this.parent.valorBcFcpRetidoSt ||
                  this.parent.aliquotaAplicavelCalculoCredito ||
                  this.parent.valorCreditoIcms) &&
                !fcpRetidoSt
              ) {
                return false;
              }
              return true;
            }
            if (codigoTributario === '900') {
              if (this.parent.valorBcFcpRetidoSt === '0') {
                return true;
              }
              if (this.parent.valorBcFcpRetidoSt && !fcpRetidoSt) {
                return false;
              }
              return true;
            }
            return true;
          }),
        valorDesoneracao: Yup.string()
          .nullable()
          .test('validaValorDesoneracao', mensagemCampoObrigatorio('Valor da desoneração (R$)'), function(
            valorDesoneracao
          ) {
            if (this.parent.motivoDesoneracao?.id && !valorDesoneracao) {
              return false;
            }
            return true;
          }),
        motivoDesoneracao: Yup.object()
          .nullable()
          .test('validaMotivoDesoneracao', mensagemCampoObrigatorio('Motivo da desoneração'), function(
            motivoDesoneracao
          ) {
            if (this.parent.valorDesoneracao === '0') {
              return true;
            }
            if (this.parent.valorDesoneracao && !motivoDesoneracao?.id) {
              return false;
            }
            return true;
          }),
        valorBcIcmsStRetido: Yup.string()
          .nullable()
          .test('validaValorBcIcmsStRetido', mensagemCampoObrigatorio('Valor da BC do ICMS ST retido (R$)'), function(
            valorBcIcmsStRetido
          ) {
            if (this.parent.aliquotaSuportadaConsumidorFinal === '0') {
              return true;
            }
            if (this.parent.valorIcmsStRetido === '0') {
              return true;
            }
            if (
              (this.parent.aliquotaSuportadaConsumidorFinal || this.parent.valorIcmsStRetido) &&
              !valorBcIcmsStRetido
            ) {
              return false;
            }
            return true;
          }),
        aliquotaSuportadaConsumidorFinal: Yup.string()
          .nullable()
          .test(
            'validaAliquotaSuportadaConsumidorFinal',
            mensagemCampoObrigatorio('Alíquota suportada pelo Consumidor Final (%)'),
            function(aliquotaSuportadaConsumidorFinal) {
              if (this.parent.valorBcIcmsStRetido === '0') {
                return true;
              }
              if (this.parent.valorIcmsStRetido === '0') {
                return true;
              }
              if (
                (this.parent.valorBcIcmsStRetido || this.parent.valorIcmsStRetido) &&
                !aliquotaSuportadaConsumidorFinal
              ) {
                return false;
              }
              return true;
            }
          ),
        valorIcmsStRetido: Yup.string()
          .nullable()
          .test('validaValorIcmsStRetido', mensagemCampoObrigatorio('Valor do ICMS ST retido (R$)'), function(
            valorIcmsStRetido
          ) {
            if (this.parent.valorBcIcmsStRetido === '0') {
              return true;
            }
            if (this.parent.aliquotaSuportadaConsumidorFinal === '0') {
              return true;
            }
            if (
              (this.parent.valorBcIcmsStRetido || this.parent.aliquotaSuportadaConsumidorFinal) &&
              !valorIcmsStRetido
            ) {
              return false;
            }
            return true;
          }),
        valorBcFcpRetidoAnteriormenteSt: Yup.string()
          .nullable()
          .test(
            'validaValorBcFcpRetidoAnteriormenteSt',
            mensagemCampoObrigatorio('Valor da BC do FCP retido anteriormente por ST (R$)'),
            function(valorBcFcpRetidoAnteriormenteSt) {
              if (this.parent.fcpRetidoAnteriormenteSt === '0') {
                return true;
              }
              if (this.parent.fcpRetidoAnteriormenteSt && !valorBcFcpRetidoAnteriormenteSt) {
                return false;
              }
              return true;
            }
          ),
        fcpRetidoAnteriormenteSt: Yup.string()
          .nullable()
          .test(
            'validaValorBcFcpRetidoAnteriormenteSt',
            mensagemCampoObrigatorio('FCP retido anteriormente por ST (%)'),
            function(fcpRetidoAnteriormenteSt) {
              if (this.parent.valorBcFcpRetidoAnteriormenteSt === '0') {
                return true;
              }
              if (this.parent.valorBcFcpRetidoAnteriormenteSt && !fcpRetidoAnteriormenteSt) {
                return false;
              }
              return true;
            }
          ),
        valorBCEfetiva: Yup.string()
          .nullable()
          .test('validaValorBCEfetiva', mensagemCampoObrigatorio('Valor da BC efetiva (R$)'), function(valorBCEfetiva) {
            if (this.parent.reducaoBCEfetiva === '0') {
              return true;
            }
            if (this.parent.aliquotaIcmsEfetiva === '0') {
              return true;
            }
            if ((this.parent.reducaoBCEfetiva || this.parent.aliquotaIcmsEfetiva) && !valorBCEfetiva) {
              return false;
            }
            return true;
          }),
        reducaoBCEfetiva: Yup.string()
          .nullable()
          .test('validaReducaoBCEfetiva', mensagemCampoObrigatorio('Redução da BC efetiva (%)'), function(
            reducaoBCEfetiva
          ) {
            if (this.parent.valorBCEfetiva === '0') {
              return true;
            }
            if (this.parent.aliquotaIcmsEfetiva === '0') {
              return true;
            }
            if ((this.parent.valorBCEfetiva || this.parent.aliquotaIcmsEfetiva) && !reducaoBCEfetiva) {
              return false;
            }
            return true;
          }),
        aliquotaIcmsEfetiva: Yup.string()
          .nullable()
          .test('validaAliquotaIcmsEfetiva', mensagemCampoObrigatorio('Alíquota do ICMS efetiva (%)'), function(
            aliquotaIcmsEfetiva
          ) {
            if (this.parent.valorBCEfetiva === '0') {
              return true;
            }
            if (this.parent.reducaoBCEfetiva === '0') {
              return true;
            }
            if ((this.parent.valorBCEfetiva || this.parent.reducaoBCEfetiva) && !aliquotaIcmsEfetiva) {
              return false;
            }
            return true;
          }),
        bcOperacaoPropria: Yup.string()
          .nullable()
          .test('validaBcOperacaoPropria', mensagemCampoObrigatorio('BC da operação própria (%)'), function(
            bcOperacaoPropria
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (this.parent.valorBcIcmsSt === '0') {
              return true;
            }
            if (this.parent.aliquotaImpostoIcmsSt === '0') {
              return true;
            }
            if (
              codigoTributario === '900' &&
              (this.parent.modalidadeDeterminacaoBcIcmsST ||
                this.parent.valorBcIcmsSt ||
                this.parent.aliquotaImpostoIcmsSt ||
                this.parent.ufIcmsStDevido?.id) &&
              !bcOperacaoPropria
            ) {
              return false;
            }
            return true;
          }),
        ufIcmsStDevido: Yup.object()
          .nullable()
          .test('validaUfIcmsStDevido', mensagemCampoObrigatorio('UF para qual é devido o ICMS ST'), function(
            ufIcmsStDevido
          ) {
            const codigoTributario = this.parent.situacaoTributaria?.codigo;

            if (!codigoTributario) return true;

            if (this.parent.valorBcIcmsSt === '0') {
              return true;
            }
            if (this.parent.aliquotaImpostoIcmsSt === '0') {
              return true;
            }
            if (this.parent.bcOperacaoPropria === '0') {
              return true;
            }
            if (
              codigoTributario === '900' &&
              (this.parent.modalidadeDeterminacaoBcIcmsST ||
                this.parent.valorBcIcmsSt ||
                this.parent.aliquotaImpostoIcmsSt ||
                this.parent.bcOperacaoPropria) &&
              !ufIcmsStDevido?.id
            ) {
              return false;
            }
            return true;
          }),
      }),
      ipi: Yup.object().shape({
        situacaoTributaria: Yup.object()
          .nullable()
          .test('situacaoTributaria', mensagemCampoObrigatorio('a situação tributária'), () => {
            return !(possuiIpi && !formik.values?.fiscal?.ipi?.situacaoTributaria?.id);
          }),
        codigoEnquadramento: Yup.string()
          .nullable()
          .test('codigoEnquadramento', mensagemCampoObrigatorio('o código de enquadramento'), () => {
            return !(
              possuiIpi &&
              formik.values?.fiscal?.ipi?.situacaoTributaria?.id &&
              !formik.values?.fiscal?.ipi?.codigoEnquadramento
            );
          }),
      }),
      cstSituacaoTributaria: Yup.object({
        id: Yup.string().nullable(),
      })
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema.test('cstSituacaoTributaria', 'Informe o código de situação tributária', (obj) => {
              if (!obj) return false;
              return !!obj.id;
            }),
        }),
      cstClassificacaoTributaria: Yup.object()
        .nullable()
        .when('cstSituacaoTributaria.id', {
          is: (id) => Boolean(id),
          then: (schema) => schema.required('Informe o código de classificação tributária'),
          otherwise: (schema) => schema.notRequired(),
        }),
      valorIbs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do IBS'))
              .min(0)
              .max(100),
        }),
      valorCbs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do CBS'))
              .min(0)
              .max(100),
        }),
      valorIs: Yup.number()
        .nullable()
        .when('ibsCbs', {
          is: true,
          then: (schema) =>
            schema
              .required(mensagemCampoObrigatorio('o valor do IS'))
              .min(0)
              .max(100),
        }),
    }),
    promocao: Yup.object().shape({
      vigenciaInicio: Yup.object()
        .nullable()
        .test('validRange', mensagemCampoObrigatorio('o período de vigência'), () => {
          if (!formik.values.emPromocao) {
            return true; // true se não está em promoção
          }
          if (!formik.values.promocao?.vigenciaInicio || !formik.values.promocao?.vigenciaFim) {
            return false; // false se está em promoção, mas não possui o período selecionado
          }
          return true; // true caso está em promoção e tem período selecionado
        }),
      desconto: Yup.string()
        .nullable()
        .test('validValue', mensagemCampoObrigatorio('o desconto'), (desconto) => {
          if (!formik.values.emPromocao) {
            return true; // true se não está em promoção
          }
          if (!desconto) {
            if (desconto === 0) {
              return true; // true se está em promoção e o valor for 0 (diferente de null e undefined)
            }
            return false; // false se null ou undefined
          }
          return true; // true se em promoção e possui valor
        })
        .test('notNegative', 'O valor de desconto não pode ser maior que o valor unitário.', (desconto) => {
          if (!formik.values.emPromocao) {
            return true;
          }

          const valorComDesconto = calcularValorComDesconto(
            formik.values?.promocao?.tipoDesconto,
            formik.values.valorUnitario,
            desconto
          );

          return valorComDesconto >= 0;
        }),
    }),
  });

  const validaCamposIcms = (campo, codigos) => {
    const icms = formik.values?.fiscal?.icms;

    if (icms && icms.possuiIcms && codigos.indexOf(icms.situacaoTributaria?.codigo) !== -1 && campo) {
      return true;
    }
    if (icms && icms.possuiIcms && codigos.indexOf(icms.situacaoTributaria?.codigo) === -1) {
      return true;
    }
    if ((icms && !icms.possuiIcms) || !icms.situacaoTributaria?.codigo) {
      return true;
    }
    return false;
  };

  const close = () => {
    formik.resetForm(initialValues);
    setAbaSelecionada(produtoAbas.dadosProduto);
    setModal('');
  };

  const handleSubmit = async (data) => {
    if (!formik?.dirty) {
      close();
      return;
    }

    const produto = JSON.parse(JSON.stringify(data));

    if (!data.emPromocao) {
      delete produto.promocao;
    }

    delete produto.possuiMovimentacao;
    delete produto.emPromocao;

    if (produto.tipoFinalidade === 'VAZIO') {
      delete produto.tipoFinalidade;
    }
    if (data.fiscal?.tipoUnidadeMedida === 'VAZIO') {
      delete produto.fiscal.tipoUnidadeMedida;
    }

    if (produto.fiscal?.codigoNCM) {
      produto.fiscal.codigoNCM = produto.fiscal.codigoNCM.id;
    }
    if (produto.fiscal?.cest) {
      produto.fiscal.cest = produto.fiscal.cest.id;
    }
    if (produto.fiscal?.cfop) {
      produto.fiscal.cfop = produto.fiscal.cfop.id;
    }
    if (produto.fiscal?.origemProduto) {
      produto.fiscal.origemProduto = produto.fiscal.origemProduto.id;
    }
    if (produto?.imagens?.length) {
      produto.imagens = produto.imagens.filter((img) => !img.error);
    }
    if (produto.fiscal?.ipi?.situacaoTributaria) {
      produto.fiscal.ipi.situacaoTributaria = produto.fiscal.ipi.situacaoTributaria.id;
    }

    if (produto.fiscal?.icms?.situacaoTributaria)
      produto.fiscal.icms.situacaoTributaria = produto.fiscal.icms.situacaoTributaria.id;
    if (produto.fiscal?.icms?.motivoDesoneracao)
      produto.fiscal.icms.motivoDesoneracao = produto.fiscal.icms.motivoDesoneracao.id;
    if (produto.fiscal?.icms?.ufIcmsStDevido)
      produto.fiscal.icms.ufIcmsStDevido = produto.fiscal.icms.ufIcmsStDevido.id;

    if (produto?.fiscal?.cstSituacaoTributaria?.id) {
      produto.fiscal.cstSituacaoTributariaId = produto.fiscal.cstSituacaoTributaria.id || null;
    }

    if (produto?.fiscal?.cstClassificacaoTributaria?.id) {
      produto.fiscal.cstClassificacaoTributariaId = produto.fiscal.cstClassificacaoTributaria.id || null;
    }

    const isUtilizadoIbsCbs =
      produto?.fiscal?.cstSituacaoTributariaId ||
      produto?.fiscal?.cstClassificacaoTributariaId ||
      produto?.fiscal?.valorIbs > 0 ||
      produto?.fiscal?.valorCbs > 0 ||
      produto?.fiscal?.valorIs > 0;

    produto.fiscal.possuiIbsCbs = !!isUtilizadoIbsCbs;

    const res = await onSubmit(produto, { q: search, page: page, size: size });

    if (res) {
      close();
    }
  };

  const handleClose = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const formik = useFormik({
    validationSchema: produtoSchema,
    initialValues,
    onSubmit: handleSubmit,
    validateOnChange: false,
    validateOnBlur: true,
  });

  useEffect(() => {
    formik.resetForm(initialValues);
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto]);

  return (
    <SimpleDialog fullScreen open={modal === produtoModais.cadastroProduto} onClose={handleClose} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Cadastro de produto',
            icon: <FaShoppingCart />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleClose}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          contentToolbar={
            <Abas
              value={abaSelecionada}
              onChange={setAbaSelecionada}
              tabs={[
                {
                  label: 'Dados do produto',
                  hasError: () => {
                    const errosProduto = Object.entries(formik.errors).filter(
                      ([key]) => key !== 'fiscal' && key !== 'promocao'
                    );

                    const errosPromocao = Object.entries(formik.errors?.promocao || {});

                    return !!(errosProduto.length || errosPromocao.length);
                  },
                },
                {
                  label: 'Dados fiscais',
                  hasError: () => {
                    const fiscalErrors = Object.entries(formik.errors?.fiscal || {});

                    const fiscalIcmsErrors = Object.entries(formik.errors?.fiscal?.icms || {});

                    const fiscalIpiErrors = Object.entries(formik.errors?.fiscal?.ipi || {});

                    return !!(fiscalErrors.length || fiscalIcmsErrors.length || fiscalIpiErrors.length);
                  },
                },
                {
                  label: 'Imagens do produto',
                  hasError: () => {
                    return false;
                  },
                },
              ]}
            />
          }
          content={
            <div className="h-full max-h-full w-full">
              {abaSelecionada === produtoAbas.dadosProduto && <TabDadosProduto />}
              {abaSelecionada === produtoAbas.dadosFiscais && <TabDadosFiscaisProduto empresaIbsCbs={empresaIbsCbs} />}
              {abaSelecionada === produtoAbas.imagens && <TabImagensProduto onUploadImage={onUploadImage} />}
            </div>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default CadastroProdutoModal;
